import { getStorePreviousUrl } from 'links/login/shared/StorePreviousUrl'

export function referrerFromSameUrl(currentPathname: string) {
	const lastUrl = getStorePreviousUrl()
	const [lastPathname] = lastUrl.split('?')

	// Both pathnames are expected to be previously encoded
	return currentPathname === lastPathname
}
